import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/Auth";
import { api, errMsg } from "../lib/api";
import { BrandMark, WaFloat, Spinner } from "../components/common";
import { Dashboard, Users, Referrals, Withdrawals, Appeals, Audit } from "./AdminOps";
import { Settings, Campaigns, Events, Simulator, Testing } from "./AdminConfig";
import { TwoFA } from "../views/Perfil";

const TABS = [
  ["resumen", "📊", "Resumen", Dashboard], ["usuarios", "👥", "Usuarios", Users], ["referidos", "🚩", "Referidos y fraude", Referrals],
  ["retiradas", "💸", "Retiradas", Withdrawals], ["reclamaciones", "📨", "Reclamaciones", Appeals], ["config", "⚙️", "Configuración", Settings],
  ["campanas", "📣", "Campañas", Campaigns], ["eventos", "🎉", "Eventos y ranking", Events], ["simulador", "🧮", "Simulador de costes", Simulator],
  ["pruebas", "🧪", "Cuentas de prueba", Testing], ["auditoria", "📜", "Auditoría y CSV", Audit], ["seguridad", "🔐", "Mi seguridad (2FA)", TwoFA],
];

function AdminLogin() {
  const { setUser, user } = useAuth();
  const [f, setF] = useState({ email: "", password: "", totp: "" });
  const [needTotp, setNeedTotp] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    try {
      const { data } = await api.post("/auth/login", { ...f, totp: f.totp || null, admin: true });
      if (data.totp_required) { setNeedTotp(true); return; }
      setUser(data.user);
    } catch (x) { setErr(errMsg(x)); }
  };
  return (
    <>
      <div className="auth-cover" style={{ gridTemplateColumns: "1fr", maxWidth: 500 }}>
        <section className="auth-card" data-testid="admin-login-page"><BrandMark big />
          <div className="auth-upper"><span className="eyebrow">ÁREA PRIVADA</span><span className="pill">🛡️ ADMIN</span></div>
          <h2>Acceso de administración</h2><p className="intro">Autorización verificada en el servidor. No existe registro público de administradores.</p>
          {user && user.role !== "admin" && <div className="auth-flow-note" data-testid="admin-not-authorized">Tu cuenta actual no tiene permisos de administración.</div>}
          <form className="auth-form visible" onSubmit={submit}>
            <div className="field"><label htmlFor="a-email">Correo de administrador</label><input id="a-email" type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} autoComplete="username" data-testid="admin-email-input" /></div>
            <div className="field"><label htmlFor="a-pass">Contraseña</label><input id="a-pass" type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} autoComplete="current-password" data-testid="admin-password-input" /></div>
            {needTotp && <div className="field"><label htmlFor="a-totp">Código 2FA</label><input id="a-totp" maxLength={6} inputMode="numeric" value={f.totp} onChange={(e) => setF({ ...f, totp: e.target.value })} data-testid="admin-totp-input" /></div>}
            <div className="auth-error" role="alert" data-testid="admin-login-error">{err}</div>
            <button className="primary" type="submit" data-testid="admin-login-submit-btn">🔐 Entrar al panel de control</button>
          </form>
          <div className="auth-actions"><a href="/" className="lime tiny">← Volver al acceso de usuarios</a></div>
        </section>
      </div>
      <WaFloat />
    </>
  );
}

export default function AdminApp() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [tab, setTab] = useState("resumen");
  if (user === null) return <Spinner />;
  if (!user || user.role !== "admin") return <AdminLogin />;
  const Comp = TABS.find((t) => t[0] === tab)[3];
  return (
    <div className="app-root">
      <div className="app">
        <aside className="side"><BrandMark />
          <nav className="nav" data-testid="admin-sidebar">{TABS.map(([k, i, l]) => <button key={k} className={tab === k ? "active" : ""} onClick={() => setTab(k)} data-testid={`admin-tab-${k}`}><span className="ico">{i}</span>{l}</button>)}
            <button onClick={() => nav("/panel/inicio")} data-testid="admin-to-user-panel"><span className="ico">⌂</span>Panel de usuario</button></nav>
        </aside>
        <main className="main">
          <header className="top"><div><div className="eyebrow">ADMINISTRACIÓN · ACCESO RESTRINGIDO</div><div className="muted tiny">{user.email}</div></div>
            <div className="right"><select className="mini-input" value={tab} onChange={(e) => setTab(e.target.value)} aria-label="Sección" data-testid="admin-mobile-tab-select" style={{ maxWidth: 170 }}>{TABS.map(([k, , l]) => <option key={k} value={k}>{l}</option>)}</select><button className="signout" onClick={logout} data-testid="admin-logout-btn">Salir ↗</button></div></header>
          <section className="view active" data-testid={`admin-view-${tab}`}><Comp /></section>
        </main>
      </div>
      <WaFloat />
    </div>
  );
}
